import { render, staticRenderFns } from "./PraticaNotes.vue?vue&type=template&id=12396cb4"
import script from "./PraticaNotes.vue?vue&type=script&lang=js"
export * from "./PraticaNotes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports